import * as React from "react";
import { MapPin, Clock, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function InTheNeighborhood() {
  return <section data-section-id="223473" id="our-service-reach" className="relative w-full min-h-[600px] md:min-h-[700px] bg-background overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666336/img/financial_growth_map.png)] bg-cover bg-center opacity-40 mix-blend-overlay" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 z-0 bg-background/60 pointer-events-none" aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 md:left-2/3 -translate-x-1/2 -translate-y-1/2 z-10 flex flex-col items-center drop-shadow-2xl">
        <div className="w-14 h-14 bg-primary rounded-lg flex items-center justify-center shadow-xl border-4 border-primary/20">
          <span className="font-default font-bold text-2xl text-primary-foreground tracking-tighter">
            LS
          </span>
        </div>
        <div className="w-0 h-0 border-l-[10px] border-r-[10px] border-t-[14px] border-l-transparent border-r-transparent border-t-primary mt-[-2px]" />
        <div className="w-6 h-2 bg-primary/30 rounded-lg mt-1 blur-[2px]" />
      </div>

      {}
      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pointer-events-none flex items-center justify-start h-full py-12 md:py-0">
        <Card className="w-full max-w-md pointer-events-auto bg-card/60 backdrop-blur-xl border-primary/20 shadow-3xl">
          <CardHeader className="pb-4">
            <CardTitle className="font-default text-3xl text-foreground tracking-tight">
              Our Service Reach
            </CardTitle>
            <CardDescription className="text-base text-muted-foreground">
              Lake Stone Enterprise provides elite financial consulting and credit management across major national hubs.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6 pb-6">
            <div className="flex items-start gap-4">
              <div className="mt-1 bg-primary/20 p-2 rounded-md shrink-0">
                <MapPin className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground mb-1">
                  National Headquarters
                </h4>
                <p className="text-muted-foreground leading-relaxed">
                  Lake Stone Enterprise, LLC<br />
                  Strategic Consulting Center
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="mt-1 bg-primary/20 p-2 rounded-md shrink-0">
                <Clock className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-semibold text-foreground mb-1">
                  Consulting Hours
                </h4>
                <p className="text-muted-foreground leading-relaxed">
                  Monday to Friday<br />
                  9am - 5pm EST
                </p>
              </div>
            </div>
          </CardContent>
          <CardFooter className="pt-2 border-t border-border/50">
            <Button asChild size="lg" className="w-full text-base h-12 shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground font-default font-semibold transition-all hover:-translate-y-1">
              <Link to="tel:18883222844">
                <Phone className="w-5 h-5 mr-2" />
                1-888-322-2844
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}